import {gql} from '@apollo/client'

export const CREATE_POLICY_STATUS = gql`
  mutation createPolicyStatus($policyStatusData: policy_status_input!) {
    createPolicyStatus(policyStatusData: $policyStatusData) {
      success
      policyStatus {
        code
        title
        color
        category
        enabledForAgents
        systemReserved
      }
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_POLICY_STATUS = gql`
  mutation updatePolicyStatus($code: String!, $policyStatusData: policy_status_input!) {
    updatePolicyStatus(code: $code, policyStatusData: $policyStatusData) {
      success
      policyStatus {
        code
        title
        color
        category
        enabledForAgents
        systemReserved
      }
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_POLICY_STATUS = gql`
  mutation deletePolicyStatus($code: String!) {
    deletePolicyStatus(code: $code) {
      success
      errors {
        field
        message
      }
    }
  }
`
